export default "__VITE_ASSET__Bi9eJxpb__"